import {Observable} from "rxjs";
import {NgxFilterConfig} from "./ngx-filter-config";

export class PageFilter {
  pageNumber: number;
  pageSize: number;
  sortName: string;
  searchBy: string;
  filters: Filter[] = [];
  sort: string;
  isSortAscending: boolean;
}

export class Filter {
  hidden?: boolean;
  field: string;
  label: string;
  hasFilter?: boolean;
  value?: any;
  valueTo?: any;
  values?: any[];
  hiddenCondition?: boolean;
  disabledCondition?: boolean;
  type: FilterTypes;
  logicalOperator: LogicalOperator;
  conditionOperator: ConditionOperator;
  conditionName?: string;
  valueName?: string;
  valueToName?: string;
  valuesName?: string;
  options? = new FilterOptions();
  displayLabel?: string;
  conditionOperators?: ConditionOperator[];
  hideRemove?: boolean ;
}

export class FilterOptions {
  selectBoxOptions? = new FilterSelectBoxOptions();
  numberBoxOptions? = new FilterNumberBoxOptions();
  trueFalseOptions? = new FilterTrueFalseOptions();
  dateTimeOptions? = new FilterDateTimeOptions();
}

export class FilterTranslator {
  constructor(data?: FilterTranslator) {
    if (data) {
      if (data.conditionLabel)
        this.conditionLabel = data.conditionLabel;
      if (data.betweenLabel)
        this.betweenLabel = data.betweenLabel;
      if (data.containsLabel)
        this.containsLabel = data.containsLabel;
      if (data.endWithLabel)
        this.endWithLabel = data.endWithLabel;
      if (data.equalLabel)
        this.equalLabel = data.equalLabel;
      if (data.exactLabel)
        this.exactLabel = data.exactLabel;
      if (data.greaterThanLabel)
        this.greaterThanLabel = data.greaterThanLabel;
      if (data.greaterThanOrEqualLabel)
        this.greaterThanOrEqualLabel = data.greaterThanOrEqualLabel;
      if (data.lessThanLabel)
        this.lessThanLabel = data.lessThanLabel;
      if (data.lessThanOrEqualLabel)
        this.lessThanOrEqualLabel = data.lessThanOrEqualLabel;
      if (data.notEqualLabel)
        this.notEqualLabel = data.notEqualLabel;
      if (data.startWithLabel)
        this.startWithLabel = data.startWithLabel;
      if (data.inRangeLabel)
        this.inRangeLabel = data.inRangeLabel;
      if (data.lastMonthLabel)
        this.lastMonthLabel = data.lastMonthLabel;
      if (data.toDayLabel)
        this.toDayLabel = data.toDayLabel;
      if (data.lastWeekLabel)
        this.lastWeekLabel = data.lastWeekLabel;
      if (data.currentMonthLabel)
        this.currentMonthLabel = data.currentMonthLabel;
      if (data.currentWeekLabel)
        this.currentWeekLabel = data.currentWeekLabel;
      if (data.currentYearLabel)
        this.currentYearLabel = data.currentYearLabel;
      if (data.fromLabel)
        this.fromLabel = data.fromLabel;
      if (data.toLabel)
        this.toLabel = data.toLabel;
      if (data.applyLabel)
        this.applyLabel = data.applyLabel;
      if (data.maxLabel)
        this.maxLabel = data.maxLabel;
      if (data.minimumLabel)
        this.minimumLabel = data.minimumLabel;
      if (data.amountLabel)
        this.amountLabel = data.amountLabel;
      if (data.notContainsLabel)
        this.notContainsLabel = data.notContainsLabel;
      if (data.clearAllLabel)
        this.clearAllLabel = data.clearAllLabel;
    }
  }

  conditionLabel = 'condition';
  betweenLabel = 'Between';
  containsLabel = 'Contains';
  notContainsLabel = 'NotContains';
  endWithLabel = 'EndsWith';
  equalLabel = 'Equal';
  exactLabel = 'Exact';
  greaterThanLabel = 'GreaterThan';
  greaterThanOrEqualLabel = 'GreaterThanOrEqual';
  lessThanLabel = 'LessThan';
  lessThanOrEqualLabel = 'LessThanOrEqual';
  notEqualLabel = 'NotEqual';
  startWithLabel = 'StartsWith';
  inRangeLabel = 'InRange';
  lastMonthLabel = 'LastMonth';
  lastWeekLabel = 'LastWeek';
  currentMonthLabel = 'CurrentMonth';
  currentWeekLabel = 'CurrentWeek';
  currentYearLabel = 'CurrentYear';
  toDayLabel = 'ToDay';
  fromLabel = 'from';
  toLabel = 'to';
  applyLabel = 'apply';
  amountLabel = 'Amount';
  minimumLabel = 'Minimum Value';
  maxLabel = 'Maximum Value';
  clearAllLabel? = 'Clear All';
}

export class FilterDateTimeOptions {
  dateLabel = 'Date';
}

export class FilterTrueFalseOptions {
  falseLabel?: string;
  trueLabel?: string;
  falseIsNull?: boolean;
}

export class FilterNumberBoxOptions {
  isMoney?: boolean;
  prefixTextForHint?: string;
  minLabel?: string;
  maxLabel?: string;
  amountLabel?: string;
}

export class FilterSelectBoxOptions {
  lazyLoad?: boolean;
  valueMember: string;
  displayMember: string;
  source?: any[];
  searcher?: (search: string, pageNumber: number, maxResultCount) => Observable<any[]>;
  useMobileView?: boolean;
  hasSearch?: boolean;
  searchBoxPlaceholder?: string;
  emptyText?: string;
  mobileViewType?: "FullScreen" | "BottomSheet";
  maximumResultForShow?: number;
  afterViewInitCallSearcher?: boolean;
  inFirstLoadSearcherValue?: string;
  noMoreResultLabel?: string;
  useInfiniteScroll?: boolean;
}

export enum LogicalOperator {
  And = 'And',
  Or = 'Or'
}

export enum ConditionOperator {
  None = 'None',
  Contains = 'Contains',
  StartWith = 'StartWith',
  EndWith = 'EndWith',
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  Between = 'Between',
  Exact = 'Exact',
  LastWeek = 'LastWeek',
  LastMonth = 'LastMonth',
  CurrentWeek = 'CurrentWeek',
  CurrentMonth = 'CurrentMonth',
  CurrentYear = 'CurrentYear',
  InRange = 'InRange',
  NotIn = 'NotIn',
  NotContains = 'NotContains',
  ToDay = 'ToDay'
}

export enum FilterTypes {
  DateTime = 1,
  Number,
  SingleSelect,
  MultiSelect,
  TextBox,
  TrueFalse,
  ListCheck
}

export class NgxApplyFilterResult {
  filters: Filter[] = [];
  filtersQueryString = '';
  filteredFilters: Filter[] = [];
}
